import { render, staticRenderFns } from "./SingleSurvey.vue?vue&type=template&id=0d227e43&"
import script from "./SingleSurvey.vue?vue&type=script&lang=js&"
export * from "./SingleSurvey.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports